/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class StudentPicker {
  async GetStudents() : Promise<Array<pxp.StudentInfo>> {
    return await componentApi.call('pxp', 'student-picker', 'StudentPicker', 'GetStudents', {
    });
  }
}
export default new StudentPicker()
